const escapeCsvField = (value: unknown, delimiter = ","): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value).replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  const shouldSurroundWithQuotes =
    stringValue.includes(delimiter) ||
    stringValue.includes('"') ||
    stringValue.includes("\n");

  if (!shouldSurroundWithQuotes) {
    return stringValue;
  }

  const escapedString = stringValue.replace(/"/g, '""');
  return `"${escapedString}"`;
};

export const toCsvRow = (row: unknown[], delimiter = ","): string => {
  return row.map((value) => escapeCsvField(value, delimiter)).join(delimiter);
};

export const toCsv = (
  rows: unknown[][],
  { delimiter = ",", eol = "\r\n", includeByteOrderMark = true } = {},
): string => {
  const body = rows.map((row) => toCsvRow(row, delimiter)).join(eol);

  if (includeByteOrderMark) {
    return `\uFEFF${body}`;
  }

  return body;
};

export const downloadCsv = (rows: unknown[][], fileName: string) => {
  const blob = new Blob([toCsv(rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};
